export function isStoryblokInspectorEnabled() {
  return useCookie('storyblok-inspector-enabled', { default: () => false }).value;
}
